import { MarkerType } from "reactflow";

import { FEActionResourceType } from "../constants/resourceTypes";
import { SourceHandle } from "../types/edges";
import { ActionNodeData, FlowNode } from "../types/nodes";

export const sourceHandleLabelMap = {
  SUCCESSFUL: "Succeeded",
  FAILED: "Failed",
  ELSE: "Else",
  APPROVED: "Approved",
  DECLINED: "Declined",
  NOT_REVIEWED: "Not Reviewed",
  PASSED: "Passed",
};

export function getSourceHandleLabel(
  node: FlowNode,
  sourceHandle?: SourceHandle
) {
  if (!sourceHandle) {
    return;
  }

  if (sourceHandle.startsWith("BR-")) {
    const branches = Object.values(
      (node?.data as ActionNodeData)?.appliedAction?.data ?? {}
    );
    const branch = branches.find((branch) => branch.id === sourceHandle);
    return `${branch?.alias}`;
  }

  return sourceHandleLabelMap[
    sourceHandle as Exclude<SourceHandle, "TEMP" | "AUTOMATION">
  ];
}
const allowedNodesToShowSourceHandle: FEActionResourceType[] = [
  "provider",
  "fraudDetection",
  "branch",
  "smartRecurringSetupCit",
  "smartRecurringProcessingMit",
  "deviceCheck",
];
export function getDefaultEdgeProps({
  sourceHandle,
  sourceNode,
  isConnectingToTrigger,
  type,
}: {
  sourceHandle?: SourceHandle;
  sourceNode: FlowNode;
  isConnectingToTrigger: boolean;
  type?: string;
}) {
  const sourceNodeResourceType = (sourceNode.data as ActionNodeData)
    ?.appliedAction?.resourceType;
  return {
    label: allowedNodesToShowSourceHandle.includes(sourceNodeResourceType)
      ? getSourceHandleLabel(sourceNode, sourceHandle)
      : undefined,
    sourceNodeType: sourceNode?.type,
    data: {
      type: type ?? ("connection" as any),
      isConnectingToTrigger,
      sourceNodeResourceType,
      sourceNodeInitialData: (sourceNode?.data as ActionNodeData)?.appliedAction
        ?.data,
    },
    markerEnd: {
      type: MarkerType.Arrow,
      width: 15,
      height: 15,
      strokeWidth: 1.5,
    },
  };
}
